import type { Analytics, AnalyticsData } from '@mwl/core-lib';
import { formatUrlToStr } from '@mwl/core-lib';

import type { GetUpcomingFilterAnalytics } from './UpcomingFilter.types';

export const getUpcomingFilterAnalytics: GetUpcomingFilterAnalytics = ({
  text,
  href,
  count,
  position,
  isActive,
}): Analytics<'click'> => {
  const analyticsData: AnalyticsData = {
    text,
    href: formatUrlToStr(href),
    count,
    position: position + 1,
  };

  if (isActive) {
    return {
      click: { eventName: 'sportTopFilter_btnUpcoming_unselect', data: analyticsData },
    };
  }

  return {
    click: { eventName: 'sportTopFilter_btnUpcoming_select', data: analyticsData },
  };
};
